// URL BASE
export const BASE_URL_SERVER = process.env.REACT_APP_BASE_URL_SERVER;

//CONSTANTES DE VALIDACION DE FORMULARIOS
export const MAX_SIZE_IMAGE_BYTES = 1000000;
export const MAX_SIZE_FILE_BYTES = 2000000;

// LATITUDES Y LONGITUDES
export const LATITUD_AYACUCHO = -37.150133;
export const LONGITUD_AYACUCHO = -58.48414;

// IDENTIFICADORES DE SERVICIOS
export const SERVICE_EMERGENCY_ID = 2;
export const SERVICE_NOTICE_ID = 3;
export const SERVICE_RESERVATION_ID = 5;

export const SERVICE_CALLS_ID = 8;

export const SERVICE_EMERGENCY_NAME = "emergency";
export const SERVICE_NOTICE_NAME = "notice";
export const SERVICE_RESERVATION_NAME = "reservation";

// URLS END POINTS
export const URL_AUTH = "auth/";
export const URL_NEWS = "notice/";
export const URL_CATEGORIES = "categories/";
export const URL_COVID = "covid/";
export const URL_ISOLATED = "isolated/";
export const URL_BUSINESS = "business/";
export const URL_USERS = "users/";
export const URL_SUBCATEGORIES = "subcategories/";
export const URL_SERVICES = "services/";
export const URL_SERVICES_V2 = "v2/services/";
export const URL_ALL_SUBCATEGORIES = "subcategories/all";
export const URL_ROLES = "roles/";
export const URL_ON_DUTY = "onduty/";
export const URL_BINS = "bins/public/";
export const URL_PING = "/ping/";
export const URL_RESIDUES = "residues/";
export const URL_RESERVATION = "reservation/";
export const URL_EVENTS = "events/";
export const URL_CALLS_SERVICE = "calls/";
export const URL_CALLS = "calls";
export const URL_SHIFT = "shifts";
export const URL_ATTENDEES = "attendees/";
export const URL_MOBILITY = "mobility/";
export const URL_MOBILITY_STATS = "stats/";
export const URL_LIVE_MOBILITY_STATS = "live/";
export const URL_CALLS_FORMS = "configurations";

export const FINAL_URL_AUTH = BASE_URL_SERVER + URL_AUTH;
export const FINAL_URL_CATEGORIES =
  BASE_URL_SERVER + URL_SERVICES + URL_NEWS + URL_CATEGORIES;
export const FINAL_URL_ALL_CATEGORIES =
  BASE_URL_SERVER + URL_SERVICES + URL_NEWS + URL_CATEGORIES + "all";
export const FINAL_URL_QUARENTINE = BASE_URL_SERVER + URL_COVID + URL_ISOLATED;
export const FINAL_URL_BUSINESS = BASE_URL_SERVER + URL_BUSINESS;
export const FINAL_URL_USERS = BASE_URL_SERVER + URL_USERS;
export const FINAL_URL_NOTICES = BASE_URL_SERVER + URL_SERVICES + URL_NEWS;
export const FINAL_URL_EMERGENCY =
  BASE_URL_SERVER + URL_SERVICES + SERVICE_EMERGENCY_NAME;
export const FINAL_URL_ROLES = FINAL_URL_USERS + URL_ROLES;
export const FINAL_URL_ON_DUTY = BASE_URL_SERVER + URL_BUSINESS + URL_ON_DUTY;
export const FINAL_URL_BINS = BASE_URL_SERVER + URL_BINS;
export const FINAL_URL_RESIDUES = BASE_URL_SERVER + URL_SERVICES_V2 + URL_RESIDUES;
export const FINAL_URL_RESERVATIONS =
  BASE_URL_SERVER + URL_SERVICES + URL_RESERVATION;
export const FINAL_URL_CALLS_SERVICE = BASE_URL_SERVER + URL_SERVICES + URL_CALLS_SERVICE;
export const FINAL_URL_ADS_SERVICE = BASE_URL_SERVER + URL_SERVICES + "ads/";
export const FINAL_URL_CALLS = FINAL_URL_CALLS_SERVICE + URL_CALLS;
export const FINAL_MOBILITY = BASE_URL_SERVER + URL_MOBILITY;
export const FINAL_MOBILITY_STATS = FINAL_MOBILITY + URL_MOBILITY_STATS;
export const FINAL_LIVE_MOBILITY_STATS = FINAL_MOBILITY_STATS + URL_LIVE_MOBILITY_STATS;
export const FINAL_URL_CALLS_FORMS = FINAL_URL_CALLS_SERVICE + URL_CALLS_FORMS;

export const FINAL_URL_MAP_PLACES = BASE_URL_SERVER + "map/places"

//RESPUESTAS SERVIDOR

export const RESPONSE_OK = 200;
export const RESPONSE_CREATED = 201;
export const RESPONSE_NO_CONTENT = 204;

//ROLES
export const ROLE_CITIZEN_ID = 1000;
export const ROLE_PENDING_VERIFICATION_CITIZEN_ID = 1001;
export const ROLE_VERIFIED_CITIZEN_ID = 1002;
export const ROLE_ADMIN_ID = 5000;
export const ROLE_PHARMACY_ADMIN_ID = 5010;
export const ROLE_POLICE_ADMIN_ID = 3001;
export const ROLE_PRESS_ADMIN_ID = 3501;
export const ROLE_HEALTH_ADMIN_ID = 3201;
export const ROLE_EVENTS_ADMIN_ID = 4501;
export const ROLE_CALLS_ADMIN_ID = 4601;
export const ROLE_MOBILITY_READER_ID = 4901;

//ROUTES
export const ROUTE_BUSINESS = "/business";
export const ROUTE_EMERGENCY = "/emergency";
export const ROUTE_NEWS = "/notices/history";
export const ROUTE_COVID = "/covid";
export const ROUTE_EVENTS = "/reservation";
export const ROUTE_CALLS_OPEN = "/calls/open"
export const ROUTE_CALLS_MY_APPLICATIONS = "/calls/my-applications"
export const ROUTE_CALLS_ADMIN = "/calls/admin/calls"


//CATEGORIAS NEGOCIOS
export const CATEGORY_PHARMACY = 6;

// TIPO DE ERRORES
export const ERROR_TYPE_DATA = 1;
export const ERROR_TYPE_SERVER = 2;

export const COLOR_PRIMARY_LIGHT = "#a8ddd7"
export const COLOR_PRIMARY = "#83CFC6"
export const COLOR_PRIMARY_DARK = "#62A59B"
export const COLOR_GRAY_ULTRA_LIGHT = "#EEEEEE"
export const COLOR_GRAY_LIGHT = "#DDDDDD"
export const COLOR_GRAY = "#AAAAAA"
export const COLOR_GRAY_DARK = "#666666"
